import submitButtonTemplate from './submitButton.ejs';
import styles from './styles.less';

interface Data {
    label?: string;
}

export default function(data: Data) {
    return submitButtonTemplate({
        ...data,
        styles,
    });
}
